import {
  SettlementParentEventTypeEnum,
  type ILPSettlementReport,
  type SettlementParentEventTypeEnum as SettlementParentEventType,
} from '@talos/kyoko';

/** Partial: websocket reports may omit parent fields (e.g. AssetTransaction / legacy). */
type LPSettlementParentEventReport = Partial<Pick<ILPSettlementReport, 'ParentEventID' | 'ParentEventType'>>;

const ORDER_PARENT_EVENT_TYPES = new Set<SettlementParentEventType>([
  SettlementParentEventTypeEnum.Order,
  SettlementParentEventTypeEnum.CareOrder,
]);

const DEAL_PARENT_EVENT_TYPES = new Set<SettlementParentEventType>([SettlementParentEventTypeEnum.Deal]);

function parentEventIdForType(
  report: LPSettlementParentEventReport,
  allowedTypes: ReadonlySet<SettlementParentEventType>
): string {
  if (report.ParentEventType == null || !allowedTypes.has(report.ParentEventType) || !report.ParentEventID) {
    return '';
  }

  return report.ParentEventID;
}

export function lpSettlementOrderId(report: LPSettlementParentEventReport): string {
  return parentEventIdForType(report, ORDER_PARENT_EVENT_TYPES);
}

export function lpSettlementDealId(report: LPSettlementParentEventReport): string {
  return parentEventIdForType(report, DEAL_PARENT_EVENT_TYPES);
}
